import React from 'react';
import {useLocalization} from 'localization';
import type {LoadStatus} from 'api';
import {ActivityIndicator, Text} from 'components';

const style: React.CSSProperties = {
  position: 'absolute',
  right: 70,
  top: 70,
};

type Props = {
  status: LoadStatus;
};

export const NorafIndicator: React.FC<Props> = ({status}) => {
  const {t} = useLocalization();

  if (status === 'Loading' || status === 'Failed') {
    return (
      <div style={style}>
        <Text kind="primary" variant="body2">
          {status === 'Loading' ? <ActivityIndicator size={'small'} /> : null}
          {status === 'Failed' ? t(`data.status.${status}`) : null}
        </Text>
      </div>
    );
  }

  return null;
};
